<template>
  <div class="main-body">
    <div class="header">评估组</div>
    <div class="out">
      <div class="search2">

        <el-button type="primary" size="mini" @click.native="toggleModalAdd">添加</el-button>

        <div style="float:right">

          <el-select v-model="institutionCode" placeholder="请选择机构" @change="insChange">
            <el-option
                v-for="item in arr_ins"
                :key="item.institutionCode"
                :label="item.userName"
                :value="item.institutionCode">
            </el-option>
          </el-select>

          <el-select
              v-model="checkinAssessClassCode"
              style="margin:0 10px;width:200px"
              placeholder="请选择评估分类">
            <el-option
                v-for="item in classData"
                :key="item.checkinAssessClassCode"
                :label="item.name"
                :value="item.checkinAssessClassCode">
            </el-option>
          </el-select>

          <el-button size="mini" type="primary" icon="el-icon-search" @click="getList">搜索</el-button>
        </div>
        <div style="clear: both;"></div>
      </div>

      <el-table class="table" size="mini" :data="tableData" :height="th" border>
        <el-table-column type="expand" v-if="tableData.length">
          <template slot-scope="props">
            <el-form label-position="left" inline class="demo-table-expand">
              <el-form-item :label="value.name" v-for="(value,i) in props.row.checkinAssessItemList" :key="i" >
                <span>{{value.fraction}}分</span>
              </el-form-item>
            </el-form>
          </template>
        </el-table-column>

        <el-table-column prop="checkinAssessClass.name" label="入住评估分类"></el-table-column>

        <el-table-column prop="name" label="名称"></el-table-column>

        <el-table-column prop="maxFraction" label="最高分"></el-table-column>

        <el-table-column prop="status" :formatter="statusTitle" label="状态"></el-table-column>
        <el-table-column prop="sort" label="排序"></el-table-column>


        <el-table-column fixed="right" label="操作" width="100">
            <template slot-scope="scope">
                <el-button type="primary" v-if="scope.row.sort" size="mini" @click="handleEdit(scope.$index, scope.row)">编辑
                </el-button>
            </template>
        </el-table-column>
      </el-table>

      <div class="page">
        <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
        <div style="float: left;">
          <el-pagination small
                         background
                         layout="prev, pager, next"
                         :total="totalItems"
                         :page-size="20"
                         @current-change="current_change">
          </el-pagination>
        </div>
        <div style="clear: both;"></div>
      </div>

    </div>

    <Add ref="myAdd" v-show="showModalAdd" v-bind:arr_ins="arr_ins"
         v-on:closeAdd="closeAdd" v-on:getList="getList"></Add>
    <Edit ref="myEdit" v-show="showModalEdit" v-bind:arr_ins="arr_ins"
          v-on:closeEdit="closeEdit" v-on:getList="getList"></Edit>

  </div>
</template>


<script>
import {timefilters, timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getStaffCode} from "@/utils/auth";

import Add from "./Add";
import Edit from "./Edit";


export default {
  name: "Page",
  data() {
    return {
      loading: false,

      showModalAdd: false,
      showModalEdit: false,


      tableData: [],

      totalItems: 0,
      pageSize: 20,
      currentPage: 1,

      th: 0,
      checkinAssessItemList: [],

      classData: [],
      checkinAssessClassCode: '',

      statusValue:['全部状态','正常','禁用'],
      status:0,

      arr_ins:[],
      institutionCode: '',


    }
  },

  created() {
    this.getIns();

    this.th = this.$store.state.tableHeight;
  },

  watch: {
    //监听全局变量
    '$store.state.tableHeight': function (val) {
      this.th = val;
    },
  },
  components: {
    Add, Edit
  },
  methods: {

    getIns(){

      this.$axios({
        method: 'post',
        url: this.$shopUrl+"Institution/ListType",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          type:1,
        }
      }).then((response) => {

        if (response.data.error === 0) {
          this.arr_ins = response.data.data.list;
          if(this.arr_ins.length>0){
            this.institutionCode = this.arr_ins[0].institutionCode;
            this.getClass();
            //this.getList();
          }
        }else if(response.data.error === 1){
          this.$message.error(response.data.message)
        }

      })

    },
    insChange(val){
      this.institutionCode = val;

      this.classData=[];
      this.checkinAssessClassCode = '';
      this.getClass();
    },

    getClass(){

      this.$axios({
        method: 'post',
        url: this.$shopUrl + "CheckinAssessClass/InsList",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          staffCode: getStaffCode(),
          institutionCode:this.institutionCode,
        }
      }).then((response) => {
        if (response.data.error == 0) {
          this.classData = response.data.data;
          if(this.classData.length>0){
            this.checkinAssessClassCode = this.classData[0].checkinAssessClassCode;
            this.getList();
          }

        } else if (response.data.error == 1) {
          this.$message({type: 'info', message: response.data.message});
        }
      }).catch(function (error) {
        console.log(error);
      });

    },



    toggleModalAdd: function () {
      this.showModalAdd = !this.showModalAdd;
      this.$refs.myAdd.init();
    },
    closeAdd: function () {
      this.showModalAdd = !this.showModalAdd;
    },

    handleEdit(index,row) {
      this.$refs.myEdit.init(row);
      this.showModalEdit = !this.showModalEdit;
    },
    closeEdit: function () {
      this.showModalEdit = !this.showModalEdit;
    },

    current_change: function (currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    getList() {

      this.$axios({
        method: 'post',
        url: this.$shopUrl + "CheckinAssessGroup/GovPage2",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          staffCode: getStaffCode(),
          institutionCode:this.institutionCode,
          checkinAssessClassCode: this.checkinAssessClassCode,
          pageIndex: this.currentPage,
          pageSize: this.pageSize,

        }
      }).then((response) => {
        this.disabledEdit=true;
        if (response.data.error == 0) {
          this.tableData = response.data.data.pageInfo.list;
          this.totalItems = response.data.data.pageInfo.total;
        } else if (response.data.error == 1) {
          this.$message({type: 'info', message: response.data.message});
        }
      }).catch(function (error) {
        console.log(error);
      });
    },

    statusTitle(row) {
      if (row.status == 0) {
        return "正常";
      }
      if (row.status == 1) {
        return "禁用";
      }
    },

    formatterTime(row, column, cellValue) {
      return timefilters(cellValue)
    },

  }
}
</script>

<style lang="scss" scoped>
/deep/ .el-table__body tr.current-row>td {
  background: rgb(121, 187, 255);
  color:#fff;
}
.checkinAssessGroup{
  .demo-table-expand /deep/ label {
    display: inline;
    color: #99a9bf;
  }

  .demo-table-expand /deep/ .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 100%;
  }
}
</style>
